import { useState } from 'react'
import { Copy, RefreshCw } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

export default function CaseConverter() {
  const [inputText, setInputText] = useState('')
  const [outputText, setOutputText] = useState('')
  const [caseType, setCaseType] = useState('lowercase')

  const convertCase = (text, type) => {
    switch (type) {
      case 'uppercase':
        return text.toUpperCase()
      case 'lowercase':
        return text.toLowerCase()
      case 'titlecase':
        return text.replace(/\w\S*/g, (txt) => 
          txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        )
      case 'sentencecase':
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      default:
        return text
    }
  }

  const handleConvert = () => {
    setOutputText(convertCase(inputText, caseType))
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(outputText)
    alert('Copied to clipboard!')
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="label">Input Text:</label>
              <textarea
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                className="input h-32"
                placeholder="Enter your text here..."
              />
            </div>
            <div>
              <label className="label">Output Text:</label>
              <textarea
                value={outputText}
                readOnly
                className="input h-32"
                placeholder="Converted text will appear here..."
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="label">Case Type:</label>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {['uppercase', 'lowercase', 'titlecase', 'sentencecase'].map((type) => (
                <label key={type} className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="case-type"
                    value={type}
                    checked={caseType === type}
                    onChange={(e) => setCaseType(e.target.value)}
                    className="mr-2"
                  />
                  <span className="text-sm">
                    {type === 'uppercase' && 'UPPERCASE'}
                    {type === 'lowercase' && 'lowercase'}
                    {type === 'titlecase' && 'Title Case'}
                    {type === 'sentencecase' && 'Sentence case'}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex gap-4">
            <Button onClick={handleConvert} variant="primary">
              <RefreshCw className="w-4 h-4 mr-2" />
              Convert
            </Button>
            <Button onClick={handleCopy} variant="secondary" disabled={!outputText}>
              <Copy className="w-4 h-4 mr-2" />
              Copy
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

